import { LoginInput } from "@finway-group/shared/lib/models"
import axios from "axios"

import LocalStorageService from "./localstorage.service"

const AuthService = {
    forgotPassword: async (email: string) => await axios.post(`/forgot-password`, { email }),
    verifyToken: async (token: string) => axios.get(`/verify/reset/${token}`),
    verifyEmailConfirmationToken: async (token: string) => await axios.get(`/verify/email/${token}`),
    updatePassword: async (loginInput: LoginInput) => axios.post("/change-password", loginInput),
    resetPassword: async (token: string, input: LoginInput) => {
        const { data } = await axios.post(`/reset/${token}`, input)
        return data
    },
    silentRefresh: async () => {
        const { data } = await axios.post("/token/refresh", {}, { withCredentials: true })
        LocalStorageService.setAccessToken(data.accessToken)
        axios.defaults.headers.common["Authorization"] = "Bearer " + data.accessToken
        return data
    },
    setCurrentCompany: async (companyId: string) => {
        const { data } = await axios.post(`/token/set-company/${companyId}`, {}, { withCredentials: true })
        LocalStorageService.setAccessToken(data.accessToken)
        axios.defaults.headers.common["Authorization"] = "Bearer " + data.accessToken
    },
    login: async (loginInput: LoginInput) => await axios.post("/login", loginInput),
    logout: async () => {
        axios.defaults.withCredentials = true
        await axios.post("/logout")
    },
    // TFA AUTH APP
    fetchTotp: async () => await axios.post("/generate-totp"),
    setupTfAuth: async (token: string) => axios.post("setup-tfauth", { token }),
    disableTfAuth: async () => await axios.post("/disable-tfauth"),
    validateToken: async (token: string) => await axios.post("/validate-totp-token", { token }),
    // TFA AUTH SMS
    enableSmsTfAuth: async () => axios.post("enable-sms-tfauth", {}),
    validateSmsTfAuthToken: async (token: string) => axios.post("validate-sms-tfauth-token", { token }),
}

export default AuthService
